// extracted by mini-css-extract-plugin
export default {"section":"section_section__ynClH","boxed":"section_boxed__ws1wB","emphasized":"section_emphasized__1fAN3","filled":"section_filled__sTMd9","paddingSm":"section_paddingSm__VdIig"};